import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss']
})
export class AudioPlayerComponent {

  @Input() audio: { name: string, file: string };
  @Input() title: string;
  @Input() index = 0;

  isPlaying = false;
  interval = 0;
  percent = 0;

  ngOnChanges() {
    this.percent = 0;
  }

  updateProgress(mp3) {
    let duration = mp3.duration * 1000;

    if (duration < 3000) {
      duration = 3000;
    }

    const interval = duration / 100;

    const playInterval = setInterval(() => {
      if (this.percent < 100) {
        this.isPlaying
          ? this.percent = mp3.currentTime / mp3.duration * 100
          : clearInterval(playInterval);
      }
    }, interval);

    mp3.onended = () => {
      setTimeout(() => {
        this.percent = 0;
        this.isPlaying = false;
        clearInterval(playInterval);
      }, 300);
    };

  }

}
